export default function Email() {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.6665 3.33331H3.33317C2.414 3.33331 1.6665 4.08081 1.6665 4.99998V15C1.6665 15.9191 2.414 16.6666 3.33317 16.6666H16.6665C17.5857 16.6666 18.3332 15.9191 18.3332 15V4.99998C18.3332 4.08081 17.5857 3.33331 16.6665 3.33331ZM16.6665 4.99998V5.42581L9.99984 10.6116L3.33317 5.42665V4.99998H16.6665ZM3.33317 15V7.53665L9.48817 12.3241C9.6341 12.4388 9.81428 12.5011 9.99984 12.5011C10.1854 12.5011 10.3656 12.4388 10.5115 12.3241L16.6665 7.53665L16.6682 15H3.33317Z"
        fill="#22303E"
        fillOpacity={0.7}
      />
    </svg>
  );
}
